export enum RedirectType {
    LOGIN = "LOGIN",
    LOGIN_AND_SECURITY_EMAIL = "LOGIN_AND_SECURITY_EMAIL",
    LOGOUT = "LOGOUT",
    LOGIN_AND_SECURITY_MOBILE = "LOGIN_AND_SECURITY_MOBILE"
}
